export default __webpack_public_path__ + "static/media/crop.27f1df7e.svg";